<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs>
            <b-tab :title="$t('attendance.attendance')" active>
              <data-table :edit-item="editItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";

export default {
  name: "AttendanceAdminIndex",
  components: {
    "data-table": DataTableVue,
  },
  data() {
    return {
      newItem: {},
    };
  },
  methods: {
    editItem(data) {
      this.form = true;
      this.newItem = data.item;
    },
  },
};
</script>
